/*=========================================================================================
  File Name: moduleNotificationsMutations.js
  Description: Notifications Module Mutations
==========================================================================================*/
import _ from "lodash";
export default {
	SET_NOTIFICATIONS(state, notifications) {
		state.notifications = notifications;
	},
	ADD_NEW_NOTIFICATION(state, notification) {
		state.notifications.unshift(notification);
	},
	DELETE_NOTIFICATIONS(state, listIds) {
		let idx = -1;
		listIds.map(id => {
			idx = _.findIndex(state.notifications, { id: id });
			if (idx !== -1) {
				if (state.notifications[idx].is_read == false) {
					state.unreadNotifications = state.unreadNotifications - 1;
				}
				state.notifications.splice(idx, 1);
				state.fiveLatestNotifications = state.notifications.slice(0, 6);
			}
		});
	},
	SET_UNREAD_NOTIFICATIONS(state, unreadNotifications) {
		state.unreadNotifications = unreadNotifications;
	},
	SET_TOTAL_NOTIFICATIONS(state, total) {
		state.totalNotifications = total;
	},
	SET_LATEST_NOTIFICATIONS(state, notifications) {
		state.fiveLatestNotifications = notifications;
	}
};
